import { makeStyles } from 'tss-react/mui';

const useStylesTooltipDialog: MaterialUIStylesCallback = makeStyles()((theme: MainTheme): MaterialUIStyles => ({
  tooltipDialog: {
    padding: '5px 10px',
    textAlign: 'center',
    color: theme.palette.common.white,
  },
  tooltipDialogButtonsBlock: {
    marginTop: 5,
  },
}));

export default useStylesTooltipDialog;
